export const SET_VIEWPORT_BREAKPOINT = 'Editor/viewport/SET_VIEWPORT_BREAKPOINT';
export const SET_VIEWPORT_CONTAINER_DOM = 'Editor/viewport/SET_VIEWPORT_CONTAINER_DOM';
export const SET_VIEWPORT_CONTENT_DOM = 'Editor/viewport/SET_VIEWPORT_CONTENT_DOM';
export const SET_VIEWPORT_WRAPPER_DOM = 'Editor/viewport/SET_VIEWPORT_WRAPPER_DOM';
export const SET_DOCUMENT_DOM = 'Editor/viewport/SET_DOCUMENT_DOM';
export const SET_SCROLLABLE_BODY_DOM = 'Editor/viewport/SET_SCROLLABLE_BODY_DOM';
export const SET_TOOLBOX_STATE = 'Editor/viewport/SET_TOOLBOX_STATE';
